import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Translate } from '../../../../language';
import { deleteWareHouse } from '../../../actions/wareHouseActions';
const DeleteModal = ({ closeModal, displayModal, wareHouse }) => {
    const divStyle = {
        display: displayModal ? 'block' : 'none'
    }
    const close = (e) => {
        closeModal(false)
    }
    //const ref = useRef(null)
    const dispatch = useDispatch();
    if(!wareHouse){
        return <></>
    }
    return <div
        className={"modal"}
        style={divStyle}
        onClick={close}>
        <div
            className="modal-content modal-content-new-post"
            onClick={e => e.stopPropagation()} >
            <div className="text-input-admin">
                desea borrar el almacen: {wareHouse.name}
            </div>
            <div className="content-buttom-create">
                <button type='button' onClick={(e) => { close(e) }} className={`btns-admin btn-create-edit btns-admin-inactive`}>{Translate('cancel', 'es')}</button>
                <button type='submit' 
                 onClick={(e) => { 
                     close(e) 
                     dispatch(deleteWareHouse(wareHouse._id))
                    }}
                className={`btns-admin btn-create-edit btns-admin-inactive`}>{Translate('delete', 'es')}</button>
            </div>
        </div>
    </div>
}
export default DeleteModal;
